import { RootState, store } from 'duck/store'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { getIsFetchingOrganizations } from 'scenes/Dashboard/data/organizations/selectors'

import { getFilteredOrganizations, resetSearch } from './duck/actions'
import OrganizationsManager, { OrganizationsManagerProps } from './presentational'

function mapStateToProps(state: RootState): StateProps {
  const isFetching = getIsFetchingOrganizations(state)

  return {
    isLoading: isFetching,
    search: state.router.location.query.search,
  }
}

type StateProps = OrganizationsManagerProps

export default compose<StateProps, {}>(
  lifecycle({
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      store.dispatch(resetSearch())
      store.dispatch(getFilteredOrganizations())
    },
  }),
  connect(mapStateToProps)
)(OrganizationsManager)
